import globals from "@lvt/globals";
import axios from "axios";
import { useState, useEffect } from "react";

import InformationalVideoModal from "./InformationalVideoModal";
import { InformationalVideo, Page } from "./types";


interface InformationalVideoModalWrapperProps {
    page: Page;
}


const InformationalVideoModalWrapper: React.FC<InformationalVideoModalWrapperProps> = ({ page }) => {
    const [video, setVideo] = useState<InformationalVideo | null>(null);
    const [isOpen, setIsOpen] = useState(true);

    const onClose = () => {
        setIsOpen(false);
        // Modal does not exist if there is no video
        recordUserView(video!.id);
    };

    const recordUserView = (id: number) => {
        axios.post(`${globals.userdashboard.proxyUrl}/api/informational_videos/${id}`)
        .then(res => {
            if (res.status !== 200) {
                console.error("Record user view request failure", res);
            }
        });
    };

    useEffect(() => {
        axios.get(`${globals.userdashboard.proxyUrl}/api/informational_videos?page=${page}`)
        .then(res => {
            if (res.status === 200) {
                const response:InformationalVideo[] = res.data.data;

                setVideo(response[0]);
            }
        });
    }, []);

    return (<>{video && <InformationalVideoModal video={video} open={isOpen} onClose={onClose}/>}</>);
};

export default InformationalVideoModalWrapper;
